import { Close16 } from '@cian/ui-kit/icons';
import * as React from 'react';

import { Drawing } from '../../../../../components/Icons';
import { ControlButton } from '../../../../../components/ControlButton';
import { IDrawButtonProps } from './types';
import { ICON_SIZE_MODIFIER_TO_CLASS } from './constants';

export const DrawButton: React.FC<IDrawButtonProps> = ({
  active,
  hasPolygons,
  iconSizeModifier = 'M',
  onActivateClick,
  onCancelClick,
  ...sharedProps
}) => {
  const className = ICON_SIZE_MODIFIER_TO_CLASS[iconSizeModifier];

  const handleClick = React.useCallback(() => {
    if (hasPolygons) {
      onCancelClick();
    } else {
      onActivateClick();
    }
  }, [hasPolygons, onActivateClick, onCancelClick]);

  return (
    <ControlButton
      {...sharedProps}
      active={active}
      className={className}
      tooltip="Выделение области"
      onClick={handleClick}
    >
      {hasPolygons ? <Close16 color={active ? 'white_100' : 'primary_100'} /> : <Drawing />}
    </ControlButton>
  );
};
